<template>
  <v-container>
    <div style="font-size: 25px; font-weight: 500;" class="mb-5">Our Top Products</div>
    <v-row>
      <v-col cols="12" sm="6" md="4" v-for="(product, t) in products" :key="t">
        <v-hover v-slot="{ hover }">
          <div class="portfolio white" @click="goto(product.to)" :style="{ backgroundImage: `url(${product.img})` }">
            <v-expand-transition>
              <div v-if="hover" class="transition-fast-in-fast-out portfolio-reveal pa-4 white--text" style="height: 100%; background-color: rgba(0, 0, 0, .5);">
                <div class="display-1">{{ product.title }}</div>
                <div class="text-justify mt-2">{{ product.desc }}</div>
              </div>
            </v-expand-transition>
          </div>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  metaInfo: () => ({
    title: 'Products | Agram Infotech',
    meta: [
      { name: 'description', content: 'Products provided by Agram Infotech' },
      { property: 'og:title', content: 'Service' },
      { property: 'og:site_name', content: 'Agram Infotech'},
      { property: 'og:description', content: 'This is home content' },
      { property: 'og:type', content: 'home' },
      { property: 'og:url', content: 'https://agraminfotech.com/products' },   
    ]
  }),
  data: () => ({
    products: [
      { title: 'Agram Digital Pathology', img: require('../../assets/icons/digital-pathology.png'), desc:'Developed by a team of specialized engineers and pathologist. Anatomical pathology procedures management system. Processes the whole workflow. Digitalize your lab.', to: '/products/agram-lab' },
      { title: 'Dairy Management', img: require('../../assets/icons/dairy-mgmt.png'), desc:'Centrally controlled Web-Application manages all other aspects of a complete accounting software with detailed options for milk procurement billing, deductions, incentives and commissions.', to: '/products/dairy-management' },
      { title: 'Health Post Management', img: require('../../assets/icons/hospital-mgmt.png'), desc:'Health Post Management Software improves quality of care and, ultimately, patient experience by optimizing the coordination of care across a hospital, practice, or ancillary care clinic.', to: '/products/hospital-management' },
      { title: 'Industry Management', img: require('../../assets/icons/industry.jpg'), desc:'An advanced software application that works as a comprehensive and one stop solution for all your business development needs', to: '/products/industry-management' },
      { title: 'Payroll Management', img: require('../../assets/icons/payroll-mgmt.png'), desc:'With Payroll Management, time tracking, and HCM in one payroll management system, it’s easier than ever to flexibly manage your processes and pay your workforce with confidence.', to: '/products/payroll-management' },
      // { title: 'UI & UX Design', img: require('../../assets/icons/ui.png'), desc:'Design interactive prototypes for Android, iOS, Web and Desktop as per your business demand. Customised user interface which includes designing, prototyping, animating, and sharing user experiences.', to: '/products/ui-ux' }
    ],
  }),
  methods: {
    goto(to) {
      this.$router.push(to)
    }
  }
}
</script>

<style scoped>
.products { height: 40vh; }
</style>